import { EmployeeRoleEnum } from "quote-export-manager-core";
import { ProductPricingV2 } from "./productpricingv2.model";

export class PriceList {

    id: number;
    serviceCode: string;
    groupingCode: string;
    salesRole: EmployeeRoleEnum;
    market: string;
    subMarket: string;
    clientSize: string;
    region: string;
    productPricings: ProductPricingV2[];
}